import { AnswerType } from "gql-gen";

interface ReportQuestionFilters {
  LoggedInUser?: "ByEmail";
}

export interface ReportQuestion {
  id: string;
  // The sqid the Rustend opine endpoints name the question by.
  sqid: string;
  key: string;
  groupKey: string;
  gogetterTitle: string;
  helper: string;
  footer?: string;
  eachProduct: boolean;
  optional: boolean;
  answerType: AnswerType;
  inputPlaceholder: string;
  // Nullable on the wire (GraphQL `[String]` over a nullable text[] column):
  // the convention is an empty array, but rows written before PINATA-698 can
  // still be NULL, so every read has to guard.
  options: string[] | null;
  notApplicableDesc: string;
  bombonAST?: string;
  hasOtherOption: boolean;
  elementSqids?: string[];
  atomTagSqids?: string[];
  atomScope: string;
  filters?: ReportQuestionFilters;
  elementTypeKey?: string;
  config?: QuestionConfig | null;
}

export interface DecimalSettings {
  maxDecimalPlaces?: number;
}

// Registry of per-answer-type config settings, keyed by the generated AnswerType
// enum. Add an entry here when an input type gains configurable settings; each
// type owns the shape of its own settings.
export interface QuestionSettingsByType {
  [AnswerType.Decimal]: DecimalSettings;
}

// Generic envelope stored in report_questions.config. `T` narrows `settings` to a
// specific answer type's shape; the default leaves it as the union of all
// registered settings.
export interface QuestionConfig<T extends keyof QuestionSettingsByType = keyof QuestionSettingsByType> {
  version?: number;
  settings?: QuestionSettingsByType[T];
  // Builder settings of a PIN picker (and of an Output, PINATA-1101): the
  // opine expressions narrowing which PINs can be picked and which start
  // selected. Both are resolved server-side; the app only forwards them.
  opine_scope?: string;
  opine_default?: string;
}

export const isNeverAnswered = (answerType: string): boolean => answerType === "pin_output" || answerType === "content";

export const isContentBlock = (answerType: string): boolean => answerType === "content";
